import $ from 'jquery';
import Foundation from './3rd/_zf.js';
import { hdConfig } from './components/config.js';

import './components/global.js';
import './components/lighthouse.js';
import './components/back-to-top.js';
import './components/script-loader.js';
import { initMenu } from './components/menu.js';
import { initSocialShare } from './components/social-share.js';
//import SimpleBar from 'simplebar';
//import ResizeObserver from 'resize-observer-polyfill';
import { Fancybox } from '@fancyapps/ui';
//import select2 from 'select2';

//window.ResizeObserver = ResizeObserver;
//select2();

// Styles
import '../sass/3rd/_index.scss';
//import 'simplebar/dist/simplebar.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';

// DOMContentLoaded
document.addEventListener('DOMContentLoaded', () => {
    initMenu('nav.nav', '.main-nav');
    initSocialShare('[data-social-share]', { intents: [ 'facebook', 'x', 'print', 'send-email', 'copy-link', 'web-share' ] });
});

Fancybox.bind('.fcy-popup, .fcy-video, .banner-video a', {});
Fancybox.bind('.wp-block-gallery .wp-block-image a, [id^="gallery-"] a, [data-rel="lightbox"]', {
    groupAll: true, // Group all items
});

jQuery(function ($) {
  let lastScrollTop = 0;
  let delta = 10;
  let header = $('#inside-header');
  let headerHeight = header.outerHeight();
  $(window).on('scroll', function () {
    let scrollTop = $(this).scrollTop();
    if (scrollTop > headerHeight) {
      header.addClass('w-sticky');
    } else {
      header.removeClass('w-sticky');
    }
    if (Math.abs(scrollTop - lastScrollTop) <= delta) return;
    if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
      header.addClass('hide-header');
    } else {
      header.removeClass('hide-header');
    }
    lastScrollTop = scrollTop;
  });
});

jQuery(document).ready(function() {
    jQuery('.scroll-body').on('click', function(e) {
        e.preventDefault();
        jQuery('html, body').animate({
            scrollTop: jQuery(window).scrollTop() + 200
        }, 300);
    });
});

// const wrapper = document.querySelector(".gallery-track"); 

// // Create array of elements to tween on
// const boxes = gsap.utils.toArray(".gallery-track .item");

// // Setup the tween
// const loop = horizontalLoop(boxes, {
//   paused: true, // Sets the tween to be paused initially
//   repeat: -1 // Makes sure the tween runs infinitely
// });

// // Start the tween
// loop.play() // Call to start playing the tween

// function horizontalLoop(items, config) {
//   items = gsap.utils.toArray(items);
//   config = config || {};
//   let tl = gsap.timeline({repeat: config.repeat, paused: config.paused, defaults: {ease: "none"}, onReverseComplete: () => tl.totalTime(tl.rawTime() + tl.duration() * 100)}),
//     length = items.length,
//     startX = items[0].offsetLeft,
//     times = [],
//     widths = [],
//     xPercents = [],
//     curIndex = 0,
//     pixelsPerSecond = (config.speed || 1) * 100,
//     snap = config.snap === false ? v => v : gsap.utils.snap(config.snap || 1), // some browsers shift by a pixel to accommodate flex layouts, so for example if width is 20% the first element's width might be 242px, and the next 243px, alternating back and forth. So we snap to 5 percentage points to make things look more natural
//     totalWidth, curX, distanceToStart, distanceToLoop, item, i;
//   gsap.set(items, { // convert "x" to "xPercent" to make things responsive, and populate the widths/xPercents Arrays to make lookups faster.
//     xPercent: (i, el) => {
//       let w = widths[i] = parseFloat(gsap.getProperty(el, "width", "px"));
//       xPercents[i] = snap(parseFloat(gsap.getProperty(el, "x", "px")) / w * 100 + gsap.getProperty(el, "xPercent"));
//       return xPercents[i];
//     }
//   });
//   gsap.set(items, {x: 0});
//   totalWidth = items[length-1].offsetLeft + xPercents[length-1] / 100 * widths[length-1] - startX + items[length-1].offsetWidth * gsap.getProperty(items[length-1], "scaleX") + (parseFloat(config.paddingRight) || 0);
//   for (i = 0; i < length; i++) {
//     item = items[i];
//     curX = xPercents[i] / 100 * widths[i];
//     distanceToStart = item.offsetLeft + curX - startX;
//     distanceToLoop = distanceToStart + widths[i] * gsap.getProperty(item, "scaleX");
//     tl.to(item, {xPercent: snap((curX - distanceToLoop) / widths[i] * 100), duration: distanceToLoop / pixelsPerSecond}, 0)
//       .fromTo(item, {xPercent: snap((curX - distanceToLoop + totalWidth) / widths[i] * 100)}, {xPercent: xPercents[i], duration: (curX - distanceToLoop + totalWidth - curX) / pixelsPerSecond, immediateRender: false}, distanceToLoop / pixelsPerSecond)
//       .add("label" + i, distanceToStart / pixelsPerSecond);
//     times[i] = distanceToStart / pixelsPerSecond;
//   }
//   function toIndex(index, vars) {
//     vars = vars || {};
//     (Math.abs(index - curIndex) > length / 2) && (index += index > curIndex ? -length : length); // always go in the shortest direction
//     let newIndex = gsap.utils.wrap(0, length, index),
//       time = times[newIndex];
//     if (time > tl.time() !== index > curIndex) { // if we're wrapping the timeline's playhead, make the proper adjustments
//       vars.modifiers = {time: gsap.utils.wrap(0, tl.duration())};
//       time += tl.duration() * (index > curIndex ? 1 : -1);
//     }
//     curIndex = newIndex;
//     vars.overwrite = true;
//     return tl.tweenTo(time, vars);
//   }
//   tl.next = vars => toIndex(curIndex+1, vars);
//   tl.previous = vars => toIndex(curIndex-1, vars);
//   tl.current = () => curIndex;
//   tl.toIndex = (index, vars) => toIndex(index, vars);
//   tl.times = times;
//   tl.progress(1, true).progress(0, true); // pre-render for performance
//   if (config.reversed) {
//     tl.vars.onReverseComplete();
//     tl.reverse();
//   }
//     return tl;
// }

//================

document.addEventListener("DOMContentLoaded", function () {
  const track = document.querySelector(".gallery-track");
  const items = gsap.utils.toArray(".gallery-track .item");

  items.forEach(item => {
    const clone = item.cloneNode(true);
    track.appendChild(clone);
  });

  const totalWidth = track.scrollWidth / 2;
  // toc do
  const speed = 60;
  gsap.to(track, {
    x: -totalWidth,
    duration: totalWidth / speed,
    ease: "none",
    repeat: -1
  });
});

//================
document.querySelector(".gallery-wrapper").addEventListener("mouseenter", () => {
  gsap.globalTimeline.timeScale(0.3);
});
document.querySelector(".gallery-wrapper").addEventListener("mouseleave", () => {
  gsap.globalTimeline.timeScale(1);
});
